<script>
export default {
    name: 'IconCross'
}
</script>
<template>
    <svg
        class="base-icon icon-cross"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M47.862 12L52 16.138 36.137 31.999 52 47.862 47.862 52 32 36.137 16.138 52 12 47.862 27.862 32 12 16.138 16.138 12 32 27.862 47.862 12z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
